import { Select, Tag } from 'antd'
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { Horizontal } from '@gravitate-js/excalibrr'

const { Option } = Select

interface IProps {
  defaultValueFormatter?: (value: string[]) => string[]
  options: string[]
  placeholder?: string
  mode: 'tags' | 'multiple'
  value: string[]
}

interface ImperativeHandle {
  getValue: () => string[]
  isPopup: () => boolean
  isCancelBeforeStart: () => boolean
  isCancelAfterEnd: () => boolean
}

export const PrioritizedSelectEditor = forwardRef<ImperativeHandle, IProps>((props, ref) => {
  const [value, setValue] = useState<string[]>(props.value || [])
  const refInput = useRef<typeof Select<string[]> | null>(null)

  useImperativeHandle(ref, () => ({
    getValue() {
      return value
    },
    isPopup() {
      return true
    },
    isCancelBeforeStart() {
      return false
    },
    isCancelAfterEnd() {
      return false
    },
  }))

  const handleChange = (newValue: string[]) => {
    setValue(newValue)
  }

  // Custom tag render function
  const customTagRender = (tagProps: { label: string; value: string; closable: boolean; onClose: () => void }) => {
    const { label, value: tagValue, closable, onClose } = tagProps
    const isFirst = value[0] === tagValue
    const displayLabel = isFirst ? `★ ${label}` : label

    return (
      <Tag color={isFirst ? 'gold' : 'default'} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
        {displayLabel}
      </Tag>
    )
  }

  return (
    <Horizontal alignItems='center'>
      <Select
        style={{ minWidth: 220, maxWidth: 440 }}
        placeholder={props.placeholder}
        mode={props.mode}
        allowClear
        onChange={handleChange}
        defaultOpen
        tagRender={customTagRender}
        ref={refInput}
        value={
          props.defaultValueFormatter && typeof props.defaultValueFormatter === 'function'
            ? props.defaultValueFormatter(value)
            : value
        }
        autoFocus
        onClear={() => setValue([])}
        placement='bottomRight'
      >
        {props.options &&
          props.options.map((optionValue) => (
            <Option key={optionValue} value={optionValue}>
              {optionValue}
            </Option>
          ))}
      </Select>
    </Horizontal>
  )
})
